import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./authReducer";
import contractReducer from "./contrcatReducer";
import notesReducer from "./notesReducer";
import orderReducer from "./orderReducer";

const store = configureStore({
  reducer: {
    auth: authReducer,
    contract: contractReducer,
    notes: notesReducer,
    order: orderReducer,
  },
});

export default store;
